import axios from "axios";
import store from "@/store";
const instance = axios.create({ baseURL: store.getters.server });

export default {
  async getId(id) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/agendas/get/"+id, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getNotifUser(user) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/agendas/getNotifUser/" + user, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getUser(user, data) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/agendas/getUser/" + user + "/" + data, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getAgendasUser(model) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.post("/agendas/getUser", model, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },

  async save(model) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.post("/agendas/save", model, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },

  async saveNotific(model) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.post("/agendas/saveNotific", model, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },

  async remove(item) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.delete("/agendas/"+item._id, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/agendas.js